import { render } from "./UserListTemplate.vue?vue&type=template&id=8dfa8122&scoped=true&ts=true"
import script from "./UserListTemplate.vue?vue&type=script&lang=ts"
export * from "./UserListTemplate.vue?vue&type=script&lang=ts"

import "./UserListTemplate.vue?vue&type=style&index=0&id=8dfa8122&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfa8122"]])

export default __exports__